import React, { createContext, useState, useContext } from 'react';

const PageCacheContext = createContext();

export const PageCacheProvider = ({ children }) => {
  const [pageCache, setPageCache] = useState({});

  const getCachedPage = (pageId) => {
    return pageCache[pageId];
  };

  const cachePage = (pageId, content) => {
    setPageCache(prevCache => ({
      ...prevCache,
      [pageId]: {
        content,
        timestamp: Date.now()
      }
    }));
  };

  const clearCache = () => {
    setPageCache({});
  };

  return (
    <PageCacheContext.Provider value={{ getCachedPage, cachePage, clearCache }}>
      {children}
    </PageCacheContext.Provider>
  );
};

export const usePageCache = () => useContext(PageCacheContext);
